import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgPrijsopbouw = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#D9F4D8"
      fillRule="evenodd"
      d="M30 34H10V6h14l3 3 3 3z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m30 12-2.95-2.93L24 6v6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M21 15.5h-9v1h9zM26.5 15.5h-4v1h4z"
    />
    <path
      fill="#00215B"
      d="M25 14h-1v4h1zM21 21.5h-9v1h9zM26.5 21.5h-4v1h4z"
    />
    <path
      fill="#00215B"
      d="M25 20h-1v4h1z"
    />
    <path
      fill="#60D15D"
      d="M24 31H12v-4h1v3h11z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgPrijsopbouw);

export default ForwardRef;
